import PublicScaffold from "@/routes/-components/PublicScaffold.js";
import { Paper } from "@mui/material";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";

export const Root = (): ReactNode => {
    return (
        <PublicScaffold>
            <Paper>
                <Outlet />
            </Paper>
        </PublicScaffold>
    );
};

export const Route = createFileRoute("/registration")({
    component: Root,
});
